module.exports = __webpack_public_path__ + "static/media/icons8-chart.0455308f.svg";